import AppRoutes from './AppRoutes';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from 'react';
import "./index.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <ToastContainer style={{
        error: {
          duration: 3000,
          style: {
            backgroundColor: '#e3e334',
            borderRadius: '30px',
            color: '#fff'
          },
        },
      }}
        closeButton={false}
        position="bottom-center" autoClose={3000} theme="colored" hideProgressBar={true} pauseOnHover={false} limit={3} />
    </div>
  );
}

export default App;